import { WebPageURL } from "./nominals";

/**
 * See snippet: wagtail_links.models.Link
 */
export const Link = WebPageURL;
export type Link = WebPageURL;
